import { render } from "./TaxReportOwners.vue?vue&type=template&id=aacc35f8&scoped=true"
import script from "./TaxReportOwners.vue?vue&type=script&lang=js"
export * from "./TaxReportOwners.vue?vue&type=script&lang=js"

import "./TaxReportOwners.vue?vue&type=style&index=0&id=aacc35f8&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aacc35f8"]])

export default __exports__